import script from "./InternalWarehouseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalWarehouseManagement.vue?vue&type=script&setup=true&lang=js"

import "./InternalWarehouseManagement.vue?vue&type=style&index=0&id=d21ec21e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d21ec21e"]])

export default __exports__